/**
 * @file supplement.actions.js
 * @description
 *
 * @copyright veriome labs, llc.  - all rights reserved.
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.md', which is part of this source code package.
 *
 * @author don michael
 * @since Nov 08, 2025 16:22
 */
// -------------------------------------------------------------------
// dialog setters
// -------------------------------------------------------------------
export const SUPPLEMENT_EDIT_DIALOG_SET = 'SUPPLEMENT_EDIT_DIALOG_SET';
export function supplementEditDialogSet(value) {
    return {
        type: SUPPLEMENT_EDIT_DIALOG_SET,
        payload: value,
    };
}

export const SUPPLEMENT_VIEW_DIALOG_SET = 'SUPPLEMENT_VIEW_DIALOG_SET';
export function supplementViewDialogSet(value) {
    return {
        type: SUPPLEMENT_VIEW_DIALOG_SET,
        payload: value,
    };
}

export const SUPPLEMENT_VIEW_RESET = 'SUPPLEMENT_VIEW_RESET';
export function supplementViewReset() {
    return {
        type: SUPPLEMENT_VIEW_RESET,
    };
}

// -------------------------------------------------------------------
// supplement.edit
// -------------------------------------------------------------------
export const SUPPLEMENT_EDIT_REQUEST = 'SUPPLEMENT_EDIT_REQUEST';
export function supplementEditRequest(supplementId) {
    return {
        type: SUPPLEMENT_EDIT_REQUEST,
        payload: {
            supplementId,
        }
    };
}

export const SUPPLEMENT_EDIT_SUCCESS = 'SUPPLEMENT_EDIT_SUCCESS';
export function supplementEditSuccess(payload) {
    return {
        type: SUPPLEMENT_EDIT_SUCCESS,
        payload,
    };
}

export const SUPPLEMENT_EDIT_FAILURE = 'SUPPLEMENT_EDIT_FAILURE';
export function supplementEditFailure(error) {
    return {
        type: SUPPLEMENT_EDIT_FAILURE,
        payload: JSON.stringify(error),
    };
}

// -------------------------------------------------------------------
// supplement.update
// -------------------------------------------------------------------
export const SUPPLEMENT_UPDATE_REQUEST = 'SUPPLEMENT_UPDATE_REQUEST';
export function supplementUpdateRequest(supplementId, changeSet) {
    return {
        type: SUPPLEMENT_UPDATE_REQUEST,
        payload: {
            supplementId,
            changeSet,
        }
    };
}

export const SUPPLEMENT_UPDATE_SUCCESS = 'SUPPLEMENT_UPDATE_SUCCESS';
export function supplementUpdateSuccess(payload) {
    return {
        type: SUPPLEMENT_UPDATE_SUCCESS,
        payload,
    };
}

export const SUPPLEMENT_UPDATE_FAILURE = 'SUPPLEMENT_UPDATE_FAILURE';
export function supplementUpdateFailure(error) {
    return {
        type: SUPPLEMENT_UPDATE_FAILURE,
        payload: JSON.stringify(error),
    };
}

// -------------------------------------------------------------------
// supplement.view
// -------------------------------------------------------------------
export const SUPPLEMENT_VIEW_REQUEST = 'SUPPLEMENT_VIEW_REQUEST';
export function supplementViewRequest(supplementId) {
    return {
        type: SUPPLEMENT_VIEW_REQUEST,
        payload: {
            supplementId,
        }
    };
}

export const SUPPLEMENT_VIEW_SUCCESS = 'SUPPLEMENT_VIEW_SUCCESS';
export function supplementViewSuccess(payload) {
    return {
        type: SUPPLEMENT_VIEW_SUCCESS,
        payload,
    };
}

export const SUPPLEMENT_VIEW_FAILURE = 'SUPPLEMENT_VIEW_FAILURE';
export function supplementViewFailure(error) {
    return {
        type: SUPPLEMENT_VIEW_FAILURE,
        payload: JSON.stringify(error),
    };
}